import { YesOrNo } from '../schemas/application-shared.schema.ts'

export const YesOrNoOptions: YesOrNo[] = ['Yes', 'No']

export const REQUIRED_BASIC_MESSAGE = 'This field is required'

export const isValidString = (value: string | undefined): boolean => {
  const isString = typeof value === 'string'
  const hasAtleastOneCharacter = isString && value?.trim().length > 0

  return hasAtleastOneCharacter
}
export const isInvalidString = (value: string | undefined): boolean => {
  return !isValidString(value)
}

export const USA_COUNTRY_CODE = 3
